<template>
	<div>
		<ChenLieNav></ChenLieNav>
		<div class="news-title" :style="{fontSize: details.titleSize ? details.titleSize : '18px'}">
			<i class="iconfont iconanchor-full"></i>
			<div style="margin: 0 20px;">
				{{details.title}}
			</div>
			<i class="iconfont iconanchor-full"></i>
		</div>
		<div class="inner-content">
			<div v-html="details.txt">

			</div>
			<div class="back" @click="$router.back(-1)">
				返回列表
			</div>
		</div>
	</div>
</template>

<script>
	import ChenLieNav from '@/components/ChenLieNav.vue'
	export default {
		name: '',
		components: {
			ChenLieNav,
		},
		data () {
			return {
				ywzlId: '',
				details: {}
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_2.png'
			that.ywzlId = this.$route.query.ywzl_id
			that.getDetails()
		},
		methods: {
			backToList() {
				this.router.back(-1)
			},
			getDetails() {
				let that = this
				that.$http.post({
					url: '/api/content/getContentById',
					data: {
						id: that.ywzlId
					}
				}).then(res => {
					if(res.code === 'S200') {
						that.details = res.data
						if(that.details.txt) {
							that.format()
						}
					}
				})
			},
			format() {
				var html = this.details.txt
				let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
					match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
					return match;
				});
				newContent = newContent.replace(/<br[^>]*\/>/gi, '');
				newContent = newContent.replace(/\<img/gi, '<img style="width:800px;height:auto;display:inline-block;margin:10rpx auto;"');
				newContent = newContent.replace(/\<video/gi, '<video style="width:800px;height:auto;display:inline-block;margin:10rpx auto;"');
				this.details.txt = newContent
			}
		}
	}
</script>

<style lang="less" scoped>
	.news-title {
		display: flex;
		height: 80px;
		line-height: 80px;
		font-size: 13px;
		color: #922627;
		text-align: center;
		justify-content: center;
		border-bottom: 3px solid #EDD68E;
		width: 1000px;
		margin: 10px auto;
		i {
			font-size: 17px;
			color: #F8C822;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/visit_service/ywzl_details.vue